/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import RequestHelper from "../../../helpers/RequestHelper";
import { getGenelDurumString } from "../../../features/loadingMessageSlice";
import { getCurrentUser } from "../../../features/currentUserSlice";
import GenelDurumHelper, { GenelDurumLoginStateHelper } from "../../../helpers/GenelDurumHelper";
import { CsmText } from "../../../library/components/mui/CsmText";
import { IMainScreenProps, MainLayout } from "../../../components/layout/MainLayout";
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { BusinessHelper } from "../../../helpers/BusinessHelper";
import Cell from "../../../library/components/layout/Cell";
import { mainScreenLocations } from "../../../app/mainScreens";
import Columns from "../../../library/components/layout/Columns";
import appColors from "../../../app/appColors";
import { SezonModel } from "../../../models/businessModels/SezonModel";
import { useScreenWidth } from "../../../library/components/hooks/useScreenWidth";
import { appIcons } from "../../../app/appIcons";
import AlertHelper from "../../../library/helpers/AlertHelper";
import Rows from "../../../library/components/layout/Rows";
import SortableMetaListPopupEditor from "./SortableMetaListPopupEditor";
import { useTranslation } from "react-i18next";
import TranslationHelper from "../../../helpers/TranslationHelper";
import CsmGenericTwoBoxListMultiSelectField from "../../../library/components/mui/twobox/CsmGenericTwoBoxListMultiSelectField";
import { VatanSezonWithNullSelectField } from "../../../components/vatan/VatanSezonSelectField";
import VatanTarzField from "../../../components/vatan/VatanTarzField";
import CsmLightCollapsableContainer from "../../../library/components/mui/containers/CsmLightCollapsableContainer";
import { VatanKonserWithNullSelectField } from "../../../components/vatan/VatanKonserSelectField";

function SarkiMetaRaporScreen() {

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const translate = TranslationHelper.TransFunc(t);
  const requestHelper = RequestHelper(navigate, dispatch, translate);

  const genelDurum = GenelDurumHelper.StringToModel(useAppSelector(getGenelDurumString)!)!;
  const user = useAppSelector(getCurrentUser);

  useEffect(() => {
    if (!user.token || genelDurum == null) {
      GenelDurumLoginStateHelper.GenelDurumYukleVeKoroAyarla(requestHelper, navigate, dispatch, user, genelDurum);
    }
  })

  if (!user.token || genelDurum == null) {
    return <></>;
  }

  const genelDurumHelper = new GenelDurumHelper(genelDurum, user, translate, navigate, dispatch, i18n, requestHelper);

  return <SarkiMetaRaporScreenInner genelDurumHelper={genelDurumHelper} />
}

function SarkiMetaRaporScreenInner(props: IMainScreenProps) {
  const { genelDurumHelper } = props;

  /* -- END OF STANDARD -- */

  const tumSarkilar = genelDurumHelper.SeciliKoroModel.tumSarkilar;

  const screenWidth = useScreenWidth();
  const isSmallScreen = screenWidth === "Max600"
  const isSmallOrMediumScreeen = isSmallScreen || screenWidth === "Max900";

  const wholeIdList = tumSarkilar.orderBy(e => e.sira).select(e => e.id);

  const [seciliSezon, setSeciliSezon] = useState<string | null>(genelDurumHelper.AktifSezon.id);
  const [seciliKonserId, setSeciliKonserId] = useState<string | null>(null);
  const [seciliAdaylikSezon, setSeciliAdaylikSezon] = useState<string | null>(null);
  const [selectedTarzIdList, setSelectedTarzIdList] = useState<string[]>([]);

  const selectableMetaFields = BusinessHelper.SarkiMeta.MetaPairs.orderByTurkish(e => e.isim);
  const [selectedMetaFieldNames, setSelectedMetaFieldNames] = useState<string[]>(["Süre", "Besteci", "Düzenleme", "Dönem", "Dil", "Uzun Açıklama"]);

  const [selectableSarkiIdList, setSelectableSarkiIdList] = useState<string[]>(tumSarkilar.where(e => e.sezonSarkiModelList.any(t => t.sezonModelId === genelDurumHelper.AktifSezon.id)).orderBy(e => e.sira).select(e => e.id));
  const [selectedSarkiIdList, setSelectedSarkiIdList] = useState<string[]>([]);

  const tumSezonlar: SezonModel[] = genelDurumHelper.SeciliKoroModel.tumSezonlar.orderByDesc(e => e.id === genelDurumHelper.AktifSezon.id ? "_" : e.isim);

  function FindSelectableSarkiList(yeniSeciliSezon: string | null, yeniSeciliKonser: string | null, yeniSeciliAdaylikSezon: string | null, yeniSeciliTarzIdList: string[]) {
    let sezonSarkilari = tumSarkilar.slice();

    if (yeniSeciliSezon !== null)
      sezonSarkilari = sezonSarkilari.where(e => e.sezonSarkiModelList.any(t => t.sezonModelId == yeniSeciliSezon));

    if (yeniSeciliKonser !== null) {
      const seciliKonser = genelDurumHelper.SeciliKoroModel.tumKonserler.singleOrDefault(e => e.id === yeniSeciliKonser);
      sezonSarkilari = sezonSarkilari.where(e => seciliKonser?.konserSarkiModelList.any(t => t.sarkiModelId === e.id) ?? false);
    }

    if (yeniSeciliTarzIdList.length > 0)
      sezonSarkilari = sezonSarkilari.where(e => e.tarzModelIdList.intersection(yeniSeciliTarzIdList).length > 0);

    if (genelDurumHelper.SeciliKoroModel.koroAyarlari.adaySarkiKullanilsin && yeniSeciliAdaylikSezon !== null)
      sezonSarkilari = sezonSarkilari.where(e => e.adaySezonModelIdList.contains(yeniSeciliAdaylikSezon));

    return sezonSarkilari.orderByTurkish(e => e.isim);
  }


  const konserChanged = (yeniSeciliKonserId: string | null) => {
    const sezonSarkilari = FindSelectableSarkiList(seciliSezon, yeniSeciliKonserId, seciliAdaylikSezon, selectedTarzIdList);
    setSelectableSarkiIdList(sezonSarkilari.select(e => e.id));
    setSeciliKonserId(yeniSeciliKonserId);
  }

  const adaylikSezonChanged = (yeniSeciliAdaylikSezonId: string | null) => {
    const sezonSarkilari = FindSelectableSarkiList(seciliSezon, seciliKonserId, yeniSeciliAdaylikSezonId, selectedTarzIdList);
    setSelectableSarkiIdList(sezonSarkilari.select(e => e.id));
    setSeciliAdaylikSezon(yeniSeciliAdaylikSezonId);
  }

  const sezonChanged = (yeniSeciliSezonId: string | null) => {
    const sezonSarkilari = FindSelectableSarkiList(yeniSeciliSezonId, seciliKonserId, seciliAdaylikSezon, selectedTarzIdList);
    setSelectableSarkiIdList(sezonSarkilari.select(e => e.id));
    setSeciliSezon(yeniSeciliSezonId);
  }

  function tarzChanged(yeniSeciliTarzIdList: string[]): void {
    const sezonSarkilari = FindSelectableSarkiList(seciliSezon, seciliKonserId, seciliAdaylikSezon, yeniSeciliTarzIdList);
    setSelectableSarkiIdList(sezonSarkilari.select(e => e.id));
    setSelectedTarzIdList(yeniSeciliTarzIdList);
  }


  const sarkiGetir = (id: string) => {
    return tumSarkilar.single(e => e.id === id);
  }

  const onSarkiEkleCikartClicked = async () => {
    const response = await AlertHelper.ShowClosableContent<string[]>("Şarkı Seçimi", closer => <Rows>
      <SortableMetaListPopupEditor
        itemLabel="şarkı"
        label="Şarkılar"
        value={selectedSarkiIdList}
        availableList={selectableSarkiIdList}
        wholeList={wholeIdList}
        labelGetter={e => sarkiGetir(e).isim}
        valueGetter={e => sarkiGetir(e).id}
        closer={closer}
        genelDurumHelper={genelDurumHelper}
      />
    </Rows>);

    if (response == null)
      return;

    setSelectedSarkiIdList(response);
  }

  const onMetaEkleCikartClicked = async () => {
    const response = await AlertHelper.ShowClosableContent<string[]>("Meta Seçimi", closer => <Rows>
      <SortableMetaListPopupEditor
        itemLabel="meta"
        label="Metalar"
        value={selectedMetaFieldNames}
        availableList={selectableMetaFields}
        labelGetter={e => e.isim}
        valueGetter={e => e.isim}
        closer={closer}
        genelDurumHelper={genelDurumHelper}
      />
    </Rows>);

    if (response == null)
      return;

    setSelectedMetaFieldNames(response);
  }

  function emptyToDash(s: string): string {
    return s === "" ? "-" : (s ?? "-");
  }

  function tabloKopyala() {
    const columnsString = ["İsim", ...selectedMetaFieldNames]

    const dataRows = selectedSarkiIdList.map((sarkiId) => {
      const sarki = sarkiGetir(sarkiId);

      const cols = selectedMetaFieldNames.select(metaName =>
        emptyToDash(BusinessHelper.SarkiMeta.MetaPairs.single(e => e.isim === metaName).field(sarki, genelDurumHelper))
      );

      return [sarki.isim, ...cols]
    })

    const text = BusinessHelper.Tablo.CSVOlustur(columnsString, dataRows);

    navigator.clipboard.writeText(text);
    AlertHelper.ShowMessage("Dikkat", "Tablo kopyalandı");
  }


  return (
    <MainLayout
      location={mainScreenLocations.sarkiMetaRapor}
      genelDurumHelper={genelDurumHelper}
      hideHeader={false}
      hideMenu={false}>
      <Rows width="100%">
        <Columns >
          <CsmLightCollapsableContainer flex ml={5} mr={5} mt={5} collapsedTitle="Filtreler" initialOpen>
            <Columns mb={5} behaveAsRows={isSmallScreen} gap={20}>
              <Columns style={{ placeItems: "center" }}>
                <CsmText style={{ minWidth: "75px", marginTop: "10px", marginLeft: "5px", marginRight: "5px" }} bold>{genelDurumHelper.translate("Sezon")}: </CsmText>
                <Cell ml={2} mt={5} style={{ minWidth: "200px" }}>
                  <VatanSezonWithNullSelectField
                    value={seciliSezon}
                    label={genelDurumHelper.translate("Sezonlar")}
                    tumSezonlar={tumSezonlar}
                    onChange={(e) => sezonChanged(e)} />
                </Cell>
                {genelDurumHelper.SeciliKoroModel.koroAyarlari.konserlerKullanilsin && <Cell mt={5} style={{ minWidth: "200px" }}>
                  <VatanKonserWithNullSelectField
                    value={seciliKonserId}
                    label={genelDurumHelper.translate("Konserler")}
                    onChange={e => konserChanged(e)}
                    tumKonserler={genelDurumHelper.SeciliKoroModel.tumKonserler.where(e => e.sezonModelId === seciliSezon)}
                  />
                </Cell>}
              </Columns>
              <Columns style={{ placeItems: "center" }}>
                <CsmText style={{ marginTop: "10px", marginLeft: "5px", marginRight: "5px" }} bold>{genelDurumHelper.translate("Tarz")}: </CsmText>
                <Cell ml={10} mt={5} style={{ minWidth: "350px" }}>
                  <VatanTarzField
                    value={selectedTarzIdList}
                    label={genelDurumHelper.translate("Tarz")}
                    onChange={e => tarzChanged(e)}
                    genelDurumHelper={genelDurumHelper}
                  />
                </Cell>
              </Columns>
              <Columns style={{ placeItems: "center" }}>
                <CsmText style={{ marginTop: "10px", marginLeft: "5px", marginRight: "5px" }} bold>{genelDurumHelper.translate("Aday Olduğu Sezonlar")}: </CsmText>
                <Cell ml={2} mt={5} style={{ minWidth: "200px" }}>
                  <VatanSezonWithNullSelectField
                    value={seciliAdaylikSezon}
                    label={genelDurumHelper.translate("Aday Olduğu Sezonlar")}
                    tumSezonlar={tumSezonlar}
                    onChange={(e) => adaylikSezonChanged(e)} />
                </Cell>
              </Columns>
              <Cell flex></Cell>
            </Columns>
            <Columns mb={5} behaveAsRows={isSmallScreen} >
              <CsmText style={{ minWidth: "75px", marginTop: "10px", marginLeft: "5px", marginRight: "5px" }} bold>{genelDurumHelper.translate("Şarkılar")}: </CsmText>
              {isSmallOrMediumScreeen ?
                <>
                  <CsmText style={{ minWidth: "75px", marginTop: "10px", marginLeft: "5px", marginRight: "5px" }}>{`${selectableSarkiIdList.length} şarkıdan ${selectedSarkiIdList.length} adedi seçili`}</CsmText>
                  <Button size="small" variant="contained" onClick={() => onSarkiEkleCikartClicked()}>{genelDurumHelper.translate("Şarkı Seçimini/Sırasını güncelle")}</Button>
                </>
                :
                <CsmGenericTwoBoxListMultiSelectField
                  itemLabel="şarkı"
                  label={genelDurumHelper.translate("Şarkılar")}
                  value={selectedSarkiIdList}
                  availableList={selectableSarkiIdList}
                  wholeList={wholeIdList}
                  labelGetter={(e) => sarkiGetir(e).isim}
                  valueGetter={(e) => sarkiGetir(e).id}
                  onChange={e => setSelectedSarkiIdList(e)}
                  sortable
                  labels={{
                    secilmeyenler: genelDurumHelper.translate("Seçilmeyenler"),
                    secilenler: genelDurumHelper.translate("Seçilenler"),
                    listeyeEklemekIcinTıklayabilirsiniz: genelDurumHelper.translate("Listeye eklemek için tıklayabilirsiniz"),
                    siralarınıDegistirmekIcinTasiyabilirsinizListedenCikartmakIcinTiklayabilirsiniz: genelDurumHelper.translate("Sıralarını değiştirmek için taşıyabilirsiniz. Listeden çıkartmak için tıklayabilirsiniz"),
                  }}
                />
              }
              <Cell flex></Cell>
            </Columns>
            <Columns mb={5} behaveAsRows={isSmallScreen} >
              <CsmText style={{ minWidth: "75px", marginTop: "10px", marginLeft: "5px", marginRight: "5px" }} bold>{genelDurumHelper.translate("Kolonlar")}: </CsmText>
              {isSmallOrMediumScreeen ?
                <>
                  <CsmText style={{ minWidth: "75px", marginTop: "10px", marginLeft: "5px", marginRight: "5px" }}>{genelDurumHelper.translate("AA kolondan BB adedi seçili", { a: selectableMetaFields.length.toFixed(), b: selectedMetaFieldNames.length.toFixed() })}</CsmText>
                  <Button size="small" variant="contained" onClick={() => onMetaEkleCikartClicked()}>{genelDurumHelper.translate("Kolon Seçimini/Sırasını güncelle")}</Button>
                </>
                :
                <CsmGenericTwoBoxListMultiSelectField
                  itemLabel="meta"
                  label={genelDurumHelper.translate("Metalar")}
                  value={selectedMetaFieldNames}
                  availableList={selectableMetaFields}
                  labelGetter={e => genelDurumHelper.translate(e.isim as any)}
                  valueGetter={e => e.isim}
                  onChange={e => setSelectedMetaFieldNames(e)}
                  sortable
                  labels={{
                    secilmeyenler: genelDurumHelper.translate("Seçilmeyenler"),
                    secilenler: genelDurumHelper.translate("Seçilenler"),
                    listeyeEklemekIcinTıklayabilirsiniz: genelDurumHelper.translate("Listeye eklemek için tıklayabilirsiniz"),
                    siralarınıDegistirmekIcinTasiyabilirsinizListedenCikartmakIcinTiklayabilirsiniz: genelDurumHelper.translate("Sıralarını değiştirmek için taşıyabilirsiniz. Listeden çıkartmak için tıklayabilirsiniz"),
                  }}
                />
              }
              <Cell flex></Cell>
            </Columns>
          </CsmLightCollapsableContainer>
        </Columns>
        <Columns style={{ margin: "10px" }}>
          <Cell flex></Cell>
          <Button variant="contained" style={{ paddingBottom: "0px" }} onClick={() => tabloKopyala()}>
            <Columns>
              <Cell>{appIcons.CrudIcons.kopyala}</Cell>
              <Cell ml={5}>{genelDurumHelper.translate("Tabloyu Kopyala")}</Cell>
            </Columns>
          </Button>
        </Columns>
        <TableContainer>
          <Table size="small" sx={{ flex: 0, minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: "bold" }} >{genelDurumHelper.translate("Şarkı İsmi")}</TableCell>
                {selectedMetaFieldNames.map(metaName =>
                  <TableCell key={metaName} style={{ fontWeight: "bold" }} align="left">{genelDurumHelper.translate(metaName as any)}</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedSarkiIdList.map((sarkiId, orderNo) => {
                const sarki = sarkiGetir(sarkiId);

                return <TableRow
                  key={sarki.id}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                    '&:nth-of-type(odd)': { backgroundColor: appColors.ACTION_HOVER },
                  }}
                >
                  <TableCell component="th" scope="row">{`${orderNo + 1}. ${sarki.isim}`}</TableCell>
                  {selectedMetaFieldNames.map(metaName =>
                    <TableCell key={metaName} align="left">{emptyToDash(BusinessHelper.SarkiMeta.MetaPairs.single(e => e.isim === metaName).field(sarki, genelDurumHelper))}</TableCell>
                  )}
                </TableRow>
              }
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Rows>
    </MainLayout>
  );
}

export default SarkiMetaRaporScreen;